import { getAvatar, getAvatarUrl } from "../constants/avatars";

const SIZES = {
  xs: "w-7 h-7",
  sm: "w-9 h-9",
  md: "w-11 h-11",
  lg: "w-14 h-14",
  xl: "w-20 h-20",
};

const STATUS_COLORS = {
  online: "bg-emerald-500",
  idle: "bg-amber-500",
  offline: "bg-slate-600",
};

export default function AvatarDisplay({ avatarId, size = "md", status, showStatus = false, className = "" }) {
  const avatar = getAvatar(avatarId);
  const imgUrl = getAvatarUrl(avatar.seed);

  return (
    <div className={`relative inline-flex shrink-0 ${className}`}>
      <div className={`${SIZES[size]} rounded-full bg-gradient-to-br ${avatar.bg} overflow-hidden ring-1 ring-white/10 shadow-md`}>
        <img
          src={imgUrl}
          alt={avatar.name}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => { e.currentTarget.style.opacity = "0.4"; }}
        />
      </div>
      {showStatus && status && (
        <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-[#07070B] ${STATUS_COLORS[status] || STATUS_COLORS.offline}`} />
      )}
    </div>
  );
}
